import { Box, H5, L40, L88, P, Stack, defaultTheme } from "@adfenix/alexandria";
import { ReactNode, FC } from "react";

import styled from "styled-components";

interface EmptyProps {
  title?: string;
  message?: string;
  cta?: ReactNode;
  unicon?: FC<{ size: number | string; color: string }>;
  fullWidth?: boolean;
}

const StyledBox = styled(Box)<{ fullWidth?: boolean }>`
  background: ${({ theme }) => theme.colors.white};
  border: ${({ theme }) => L88(theme.colors.grey)} 2px solid;
  ${({ theme }) => theme.borderRadius.l};
  max-width: ${({ fullWidth }) => (fullWidth ? "100%" : "680px")};
  text-align: center;
`;

export const Empty = ({
  cta,
  unicon,
  title,
  message,
  fullWidth
}: EmptyProps) => {
  return (
    <StyledBox fullWidth={fullWidth} pY="xl2" pX="xl5">
      <Box
        alignItems="center"
        justifyContent="center"
        display="flex"
        flexDirection="column"
      >
        {unicon &&
          unicon({
            size: defaultTheme.fonts.xl5["font-size"],
            color: L40(defaultTheme.colors.grey)
          })}

        <Stack spacing="xs2">
          <H5>{title}</H5>
          <P>{message}</P>
        </Stack>

        {cta && (
          <Box pX="l" display="flex" justifyContent="center">
            {cta}
          </Box>
        )}
      </Box>
    </StyledBox>
  );
};
